<template>
  <div class="content">
    <div class="bodycontent">
      <div class="act-main-center">
        <div class="act-main-title">
          <span>活动基本信息</span>
        </div>
        <!--活动基本信息-->
        <div class="act-main-form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            style="padding-top:20px"
          >
            <el-form-item label="活动名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="适用门店" prop="resource">
              <el-radio-group v-model="ruleForm.resource">
                <el-radio label="全部门店"></el-radio>
                <el-radio label="指定门店"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动时间" required style="width:100%">
              <el-col :span="11">
                <el-form-item prop="date1">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="ruleForm.start_time"
                    style="width: 88%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="date1">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="ruleForm.end_timete1"
                    style="width: 88%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="参与对象" prop="type">
              <el-radio-group v-model="ruleForm.type">
                <el-radio label="不限" name="type"></el-radio>
                <el-radio label="全部粉丝" name="type"></el-radio>
                <el-radio label="全部会员" name="type"></el-radio>
                <el-radio label="按会员等级" name="type"></el-radio>
                <el-radio label="按用户标签" name="type"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动备注" prop="desc">
              <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!--满减满折-->
        <div class="act-main-title">
          <span>满减满折</span>
        </div>
        <div class="act-main-form">
          <el-form
            :model="discountsForm"
            :rules="disRules"
            ref="ruleForm"
            label-width="100px"
            style="padding-top:20px;width:60%"
            class="demo-ruleForm"
          >
            <el-form-item label="优惠方式" prop="resource">
              <el-radio-group v-model="discountsForm.type">
                <el-radio label="单次减免优惠"></el-radio>
                <el-radio label="每满减优惠"></el-radio>
                <el-radio label="满折优惠"></el-radio>
              </el-radio-group>
            </el-form-item>
            <!--单次减免-->
            <template v-if="discountsForm.type == '单次减免优惠'">
              <div class="act-addyou">
                <div class="act-addyou-con">
                  <span>优惠等级</span>
                  <div>
                    <label for="">满</label>
                    <el-input type="number"></el-input>
                  </div>
                  <div>
                    <label for="">减</label>
                    <el-input type="number"></el-input>
                  </div>
                  <el-button style="background:#2F54EB;color:#fff"
                    >添加优惠</el-button
                  >
                </div>
                <el-table :data="tableData" style="margin-top:20px">
                  <el-table-column prop="date" label="优惠等级" width="180">
                  </el-table-column>
                  <el-table-column prop="name" label="满(元)" width="180">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    label="减(元)"
                  ></el-table-column>
                  <el-table-column prop="address" label="操作">
                    <template>
                      <el-button type="text">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
            <!--每满减优惠-->
            <template v-if="discountsForm.type == '每满减优惠'">
              <div class="max-youhui">
                <div class="max-youhui-item">
                  <div class="max-youhui-child">
                    <span>每满</span>
                    <el-input
                      v-model="ruleForm.name"
                      maxlength="10"
                      show-word-limit
                    ></el-input>
                    <span style="margin-left:10px">元</span>
                  </div>
                  <div class="max-youhui-child">
                    <span>减</span>
                    <el-input
                      v-model="ruleForm.name"
                      maxlength="10"
                      show-word-limit
                    ></el-input>
                    <span style="margin-left:10px">元</span>
                  </div>
                </div>
                <div class="max-youhui-bottom">
                  <label for="maxyou">最高优惠</label>
                  <el-input
                    id="maxyou"
                    type="number"
                    style="width:150px"
                  ></el-input>
                  <span>注意: -1为无最高优惠上限限制,最高优惠金额不能低于满减金额</span>
                </div>
              </div>
            </template>
            <!--满折优惠-->
            <template v-if="discountsForm.type == '满折优惠'">
              <div class="act-addyou">
                <div class="act-addyou-con">
                  <span>优惠等级</span>
                  <div>
                    <label for="">满</label>
                    <el-input type="number"></el-input>
                  </div>
                  <div>
                    <label for="">折</label>
                    <el-input type="number"></el-input>
                  </div>
                  <el-button style="background:#2F54EB;color:#fff"
                    >添加优惠</el-button
                  >
                </div>
                <el-table :data="tableData" style="margin-top:20px">
                  <el-table-column prop="date" label="优惠等级" width="180">
                  </el-table-column>
                  <el-table-column prop="name" label="满(元)" width="180">
                  </el-table-column>
                  <el-table-column prop="address" label="折"></el-table-column>
                  <el-table-column prop="address" label="操作">
                    <template>
                      <el-button type="text">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
            <el-form-item label="优惠时间" prop="type">
              <el-checkbox-group v-model="discountsForm.distime">
                <el-checkbox
                  v-for="item in initDisTime"
                  :key="item"
                  :label="item"
                  name="type"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="act-main-title">
          <span>折扣活动</span>
        </div>
        <div class="act-main-bottom">
          <span>满减满折,创建活动后自动开启</span>
          <div class="act-main-bottom-item">
            <label>会员等级折扣</label>
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="status_form.vip"
              style="margin-left:20px"
            ></el-switch>
            <span>已关闭</span>
          </div>
          <div class="act-main-bottom-item">
            <label>优惠券</label>
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="status_form.coupon"
              style="margin-left:20px"
            ></el-switch>
          </div>
          <div class="act-main-bottom-item">
            <label style="margin-right:10px">是否优惠同享</label>
            <el-radio v-model="status_form.enjoy" label="1">同享</el-radio>
            <el-radio v-model="status_form.enjoy" label="2">不同享</el-radio>
          </div>
        </div>
        <div class="act-main-title">
          <span>资产抵扣</span>
        </div>
        <div class="act-main-bottom">
          <div class="act-main-bottom-item">
            <label>电子礼品</label>
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="status_form.gifts"
              style="margin-left:20px"
            ></el-switch>
            <span>已关闭</span>
          </div>
          <div class="act-main-bottom-item">
            <label>积分</label>
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="status_form.integral"
              style="margin-left:20px"
            ></el-switch>
          </div>
          <div class="act-main-bottom-item">
            <label>余额</label>
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="status_form.balance"
              style="margin-left:20px"
            ></el-switch>
          </div>
          <div class="act-main-bottom-item">
            <label style="margin-right:10px"
              >【电子礼品】与【余额】是否共享</label
            >
            <el-radio v-model="status_form.zcenjoy" label="1">同享</el-radio>
            <el-radio v-model="status_form.zcenjoy" label="2">不同享</el-radio>
          </div>
          <div class="act-main-bottom-btn">
            <el-button type="primary">提交</el-button>
            <el-button>取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        start_time: "",
        end_time: "",
        type: "不限",
        resource: "全部门店",
        desc: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ],
        start_time: [
          {
            type: "date",
            required: true,
            message: "开始日期",
            trigger: "change"
          }
        ],
        end_time: [
          {
            type: "date",
            required: true,
            message: "结束日期",
            trigger: "change"
          }
        ],
        desc: [{ required: true, message: "请填写备注信息", trigger: "blur" }]
      },
      initDisTime: [
        "整周",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
        "周日"
      ],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      discountsForm: {
        type: "单次减免优惠",
        distime: []
      },
      status_form: {
        vip: false,
        enjoy: "1",
        coupon: false,
        gifts: false,
        integral: false,
        balance: false,
        zcenjoy: "1"
      },
      disRules: {
        distime: [
          {
            type: "array",
            required: true,
            message: "请至少选一个活动时间",
            trigger: "change"
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../sub_com";
$bg: rgb(250, 250, 250);
.bodycontent {
  background: none;
  padding: 10px 10px;
}
.act-main-center {
  width: 100%;
  height: auto;
  border-radius: 10px;
  .act-main-title {
    width: 100%;
    height: 40px;
    color: #333333;
    font-size: 16px;
    line-height: 40px;
    padding-left: 10px;
    margin-top: 10px;
    background: #fff;
  }
  .act-main-form {
    width: 100%;
    height: auto;
    display: flex;
    background: #fff;
    margin-top: 10px;
    border-radius: 10px;
    flex-direction: column;
    .act-addyou {
      width: 100%;
      padding-left: 20px;
      .act-addyou-con {
        width: 50%;
        height: 50px;
        display: flex;
        padding-left: 10px;
        justify-content: space-between;
        align-items: center;
        div {
          width: 100px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .el-input {
            width: 80px;
          }
        }
      }
    }
    .max-youhui {
      width: 100%;
      height: auto;
      display: flex;
      padding-left: 30px;
      flex-direction: column;
      .max-youhui-item {
        width: 60%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .max-youhui-child {
          display: flex;
          align-items: center;
          span {
            display: block;
            width: 80px;
          }
        }
        label {
          display: block;
          width: 100px;
        }
      }
      .max-youhui-bottom {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        .el-input {
          margin-left: 20px;
        }
        span {
          margin-left: 20px;
          color: #999999;
        }
      }
    }
    .demo-ruleForm {
      width: 40%;
      .act-item {
        width: 100%;
        height: 50px;
        display: flex;
        padding-left: 50px;
        align-items: center;
        label {
          width: 80px;
          display: block;
        }
        .act-item-input {
          width: 20%;
        }
      }
    }
  }
  .act-main-bottom {
    width: 100%;
    height: auto;
    display: flex;
    background: #fff;
    padding-left: 32px;
    margin-top: 10px;
    padding: 10px;
    border-radius: 10px;
    flex-direction: column;
    .act-main-bottom-item {
      width: 100%;
      margin-top: 20px;
      span {
        margin-left: 10px;
      }
    }
    .act-main-bottom-btn {
      margin-top: 40px;
    }
  }
}
</style>
